// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_i4-1";
export var quotedThread = "_i4-0";